export default "__VITE_ASSET__2d420e0a__"